import React from 'react'

import NotificationCenter from './NotificationCenter'
import ProfileMenu from './ProfileMenu'
import { useUser } from '../../../context'
import { RoleTone } from '../../constants'

import { Header, HeaderActions, HeaderCopy, HeaderInner } from './styles'

const ShellHeader = () => {
  const { user, userRole } = useUser()
  const role = (userRole || 'student') as RoleTone

  return (
    <Header>
      <HeaderInner>
        <HeaderCopy>
          <span>Tu espacio de canto</span>
          <h1>
            Hola, {user?.name || 'Pia'} <span aria-hidden="true">👋</span>
          </h1>
          <p>Hoy tienes una nueva oportunidad para hacer sonar tu voz.</p>
        </HeaderCopy>

        <HeaderActions>
          <NotificationCenter role={role} />
          <ProfileMenu role={role} />
        </HeaderActions>
      </HeaderInner>
    </Header>
  )
}

export default ShellHeader
